import { render } from "./StuffCard.vue?vue&type=template&id=b42cba84&scoped=true"
import script from "./StuffCard.vue?vue&type=script&lang=js"
export * from "./StuffCard.vue?vue&type=script&lang=js"

import "./StuffCard.vue?vue&type=style&index=0&id=b42cba84&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/Mosolysziget/Mosolysziget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b42cba84"]])

export default __exports__